import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CellSelectionSimple from './CellSelectionSimple';
import { useSortedSelectionsIds } from '~SpectateStore/hooks/selectionsHooks';
import './styles/gridBasic.scss';

const SelectionsGridBasic = ({ eventId, marketId, isYesNoMarket }) => {
    const selectionsIds = useSortedSelectionsIds(eventId, marketId);
    const gridClass = classNames('basic-grid', {
        'basic-grid--list': !isYesNoMarket,
        'basic-grid--yes-no': isYesNoMarket,
    });

    return (
        <div className={gridClass}>
        {
            selectionsIds.map(id =>
                <CellSelectionSimple
                    key={`selection-${id}`}
                    id={id}
                />
            )
        }
       </div>
    );
};

SelectionsGridBasic.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    marketId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    isYesNoMarket: PropTypes.bool,
};

export default SelectionsGridBasic;
